export const routes = {
  main: '/',
  settings: '/settings',
  notExistingRoute: '*',
  components: '/components',
  login: '/login',
}
